import { Colors, Typography } from '@zapier/design-system';
import { css } from '@emotion/react';
import { mediaQueries } from '@zapier/identity-utils';
import { useTranslations } from 'next-intl';
import { FeatureItem, FeatureItemList } from '../FeatureItem';

const rootStyles = css`
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: center;
  width: 100%;
`;

const headerStyles = css`
  ${Typography.PageHeader}
  color: ${Colors.GrayWarm10};
  margin-bottom: 30px;
  text-align: center;

  ${mediaQueries.tablet} {
    text-align: left;
  }

  ${mediaQueries.desktop} {
    ${Typography.PageHeader}
  }
`;

export function SignUpPromo() {
  const t = useTranslations('signup-features');

  return (
    <div css={rootStyles}>
      <div css={headerStyles}>{t('heading')}</div>
      <FeatureItemList>
        <FeatureItem>{t('easy-setup')}</FeatureItem>
        <FeatureItem>{t('free-forever')}</FeatureItem>
        <FeatureItem>{t('trial')}</FeatureItem>
      </FeatureItemList>
    </div>
  );
}
